import React from 'react';

function Footer({data}) {

    if(data){
      var networks= data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>

           <ul>
            <li>Credit to Tim Baker & the Clever Programmer team</li>
           </ul>

           <ul className="copyright">
              <li>&copy; 2020- Alexandros Xafopoulos</li>
              <li>Design by <a title="Styleshout" href="http://www.styleshout.com/">Styleshout</a></li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
}

export default Footer;
